export default "__VITE_ASSET__2ef38426__"